// Languages offered for org-level UI preference. Scandinavian + English by
// product spec; widen the list when the product launches outside the Nordics.
//
// `code` is ISO 639-1 (lowercase 2-letter). `nativeName` is the language's
// own name — UX research shows users pick faster when they see their
// language in their own script ("Svenska" not "Swedish"). `englishName` is
// the fallback for users not from any Scandinavian country.

export interface Language {
  code: string;
  nativeName: string;
  englishName: string;
}

export const languages: readonly Language[] = [
  { code: 'en', nativeName: 'English',   englishName: 'English' },
  { code: 'sv', nativeName: 'Svenska',   englishName: 'Swedish' },
  { code: 'no', nativeName: 'Norsk',     englishName: 'Norwegian' },
  { code: 'da', nativeName: 'Dansk',     englishName: 'Danish' },
  { code: 'fi', nativeName: 'Suomi',     englishName: 'Finnish' },
];

const codeIndex = new Map(languages.map((l) => [l.code, l]));

export function findLanguage(code: string): Language | undefined {
  return codeIndex.get(code.toLowerCase());
}
